import { ref ,shallowRef,watch} from '@vue/composition-api'
import { reportService } from '@/app/reports/containerWashPlan/services/containerWashPlan.report.service'

import  ReportOptions from  '@/views/reports/components/options.js'

const  {defaultFromdate,defaultTodate} = ReportOptions()

export default function ReportLogic() {

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const request = ref({
    page: 1,
    length: 25,
    type: 'containerWashPlan',
    from: defaultFromdate,
    to: defaultTodate,
    plans: []
  })

  const reportData = shallowRef(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading = ref(false)

  watch([sortBy,isSortDirDesc],()=>{
   
    request.value.sortBy = isSortDirDesc.value == true ? sortBy.value + ',desc':sortBy.value + ',asc';
    dataTableloading.value = true

    reportService.getReport(request.value)
    .then(res => {
      reportData.value = res.data.data
      from.value = res.data.from
      to.value = res.data.to
      total.value = res.data.total
       
    })
    .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    .finally(() =>  dataTableloading.value = false)
  })

  const getReport = () => {

    errors.value = {}
    loading.value = true
    
    reportService.getReport(request.value)
      .then(res => {
        reportData.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }


  return {
    getReport,
    reportData,
    total, 
    from, 
    to,
    request,
    loading,
    dataTableloading,
    errors,
    sortBy,
    isSortDirDesc
  }
}
